import { jsx as _jsx } from "react/jsx-runtime";
import AnchorLink from '../../../components/AnchorLink';
import styles from '../../../components/RichText/RichText.module.scss';
import { extractInlineStyles, extractChildElementInlineStyles } from '../utils';
function handleCmsLocation(href) {
    const base = '/content/waitrosegroceriescms/en';
    const isCmsLocation = href.includes(base);
    if (isCmsLocation) {
        const [, cmsLocation] = href.split(base);
        return `/ecom${cmsLocation.replace('.html', '')}`;
    }
    return href;
}
const RichTextAnchor = ({ value, children, onRichTextClick }) => {
    const { attributes } = value;
    const { href, target, title = '' } = attributes || {};
    if (!href) {
        return children;
    }
    const inlineStyles = Object.assign(Object.assign({}, extractInlineStyles({ attributes })), extractChildElementInlineStyles(value, 'span'));
    const url = handleCmsLocation(href);
    const handleOnClick = () => {
        const newWindow = target === '_blank';
        onRichTextClick({ newWindow, title, linkUrl: url });
    };
    return (_jsx(AnchorLink, { className: styles.anchor, href: url, onClick: handleOnClick, style: inlineStyles, target: target, title: title, children: children }));
};
RichTextAnchor.displayName = 'RichTextAnchor';
export default RichTextAnchor;
//# sourceMappingURL=Anchor.js.map